// GET /cosmetics/index - the cosmetic artwork catalogue the mobile app keeps
// on the phone, so new cosmetics arrive with a server deploy instead of an
// app release. Each map is assetKey -> raw SVG markup.
export interface CosmeticsIndex {
  /** Content hash; also the response ETag. */
  version: string;
  badges: Record<string, string>;
  banners: Record<string, string>;
  frames: Record<string, string>;
  stamps: Record<string, string>;
}

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

/** A title's `metadata.colorHex`, if it is a plain #RRGGBB colour. Clients
 *  use it for colour tokens they were built before, so a new title colour
 *  needs no client release. */
export function titleColorHex(hex: unknown): string | undefined {
  return typeof hex === "string" && HEX_RE.test(hex) ? hex : undefined;
}
